import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '首页',
      requiresAuth: true
    }
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/My.vue'),
    meta: {
      title: '我的',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '登录',
      fullScreen: true,
      showNavBar: false
    }
  },
  // 首页功能路由
  {
    path: '/merit',
    name: 'merit',
    component: () => import('../views/Merit.vue'),
    meta: {
      title: '评优申请',
      requiresAuth: true
    }
  },
  {
    path: '/leave',
    name: 'leave',
    component: () => import('../views/Leave.vue'),
    meta: {
      title: '请假申请',
      requiresAuth: true
    }
  },
  {
    path: '/reissue',
    name: 'reissue',
    component: () => import('../views/Reissue.vue'),
    meta: {
      title: '补办业务',
      requiresAuth: true
    }
  },
  {
    path: '/material',
    name: 'material',
    component: () => import('../views/Material.vue'),
    meta: {
      title: '资料文件',
      requiresAuth: true
    }
  },
  // 我的功能路由
  {
    path: '/my-discipline',
    name: 'myDiscipline',
    component: () => import('../views/MyDiscipline.vue'),
    meta: {
      title: '我的处分',
      requiresAuth: true
    }
  },
  {
    path: '/my-merit',
    name: 'myMerit',
    component: () => import('../views/MyMerit.vue'),
    meta: {
      title: '我的评优',
      requiresAuth: true
    }
  },
  {
    path: '/my-volunteer',
    name: 'myVolunteer',
    component: () => import('../views/MyVolunteer.vue'),
    meta: {
      title: '志愿服务',
      requiresAuth: true
    }
  },
  {
    path: '/my-leave',
    name: 'myLeave',
    component: () => import('../views/MyLeave.vue'),
    meta: {
      title: '我的请假',
      requiresAuth: true
    }
  },
  {
    path: '/my-reissue',
    name: 'myReissue',
    component: () => import('../views/MyReissue.vue'),
    meta: {
      title: '我的补办',
      requiresAuth: true
    }
  },
  {
    path: '/volunteer',
    name: 'volunteer',
    component: () => import('../views/Volunteer.vue'),
    meta: {
      title: '志愿服务',
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  routes
})


router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;

  // 若 store 中还未登录状态，尝试从 localStorage 恢复
  if (!isLoggedIn) {
    await store.dispatch('checkLoginStatus');
  }

  const finalLoggedIn = store.getters.isLoggedIn;

  if (to.path === '/login' && finalLoggedIn) {
    return next('/');
  }

  if (to.meta.requiresAuth && !finalLoggedIn) {
    return next('/login');
  }

  next();
});

export default router
